import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';
import { FormConfig } from '../../definition/types/subscription';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  feilds = {
    investmentAmount: 'girardinInvestmentAmount',
    taxReductionAmount: 'girardinTaxReductionAmount',
    girardinCommissionRate: 'girardinCommissionRate',
  };
  generateForm(entity: PledgeProductRead & { parameters: any }, option: any) {
    let options: AbstractControlOptions = {};
    const parameters: Parameters = {
      ...option,
    };

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        girardinInvestmentAmount: [
          entity?.parameters?.girardinInvestmentAmount || null,
          this.girardinInvestmentAmountRequired(parameters)
            ? Validators.required
            : Validators.nullValidator,
        ],
        girardinTaxReductionAmount: [
          {
            value: entity?.parameters?.girardinTaxReductionAmount || null,
            disabled:
              entity?.parameters?.partnerFlux === 'FINANCILE' ||
              entity?.parameters?.partnerFlux === 'OSEOM',
          },
          this.girardinTaxReductionAmountRequired(parameters)
            ? Validators.required
            : Validators.nullValidator,
        ],
        girardinCommissionRate: [
          this.roundTwoDigits(
            entity?.parameters?.girardinCommissionRate * 100,
          ) || null,
          this.girardinCommissionRateRequired(parameters)
            ? Validators.required
            : Validators.nullValidator,
        ],
      }),
    };
    return this.formBuilder.group(formConfig, options);
  }
  roundTwoDigits(value: number | null) {
    return value != null ? Math.round(value * 100) / 100 : null;
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  girardinCommissionRateRequired(parameters: Parameters) {
    return (
      this.getAdditionalQuestions(
        parameters,
        CompanyFieldType.GIRARDIN_COMMISSION_RATE,
      )?.required === 'MANDATORY' || false
    );
  }
  girardinTaxReductionAmountRequired(parameters: Parameters) {
    return (
      this.getAdditionalQuestions(
        parameters,
        CompanyFieldType.GIRARDIN_TAX_REDUCTION_AMOUNT,
      )?.required === 'MANDATORY' || false
    );
  }
  girardinInvestmentAmountRequired(parameters: Parameters) {
    return (
      this.getAdditionalQuestions(
        parameters,
        CompanyFieldType.GIRARDIN_INVESTMENT_AMOUNT,
      )?.required === 'MANDATORY' || false
    );
  }
  getAdditionalQuestions(parameters: Parameters, type: any) {
    return parameters?.additionalQuestions?.find(q => q?.id === type);
  }

  extract() {
    const formValue = _.cloneDeep(this.form?.value?.products);
    formValue?.forEach(item => {
      if (item?.parameters?.girardinCommissionRate)
        item.parameters.girardinCommissionRate =
          +item.parameters.girardinCommissionRate / 100;
    });
    return formValue;
  }
}
